import { create } from 'zustand';

export const GlobalErrorType = {
  SERVICE_OUTAGE: 'SERVICE_OUTAGE',
} as const;

export type GlobalErrorType = (typeof GlobalErrorType)[keyof typeof GlobalErrorType];

interface ErrorState {
  globalError: GlobalErrorType | null;
  setGlobalError: (errorType: GlobalErrorType | null) => void;
  clearGlobalError: () => void;
}

export const useErrorStore = create<ErrorState>((set) => ({
  globalError: null,
  setGlobalError: (errorType) => set({ globalError: errorType }),
  clearGlobalError: () => set({ globalError: null }),
}));
